export const ImageLevel = {
    transparent: 'transparent',
    primary: 'primary',
    secondary: 'secondary',
};
export const ImageResize = {
    fill: 'fill', // In CSS = cover
    fit: 'fit', // In Css = contain
};
